var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Subtitles")]),
      _c(
        "md-layout",
        {
          staticClass: "info-subtitles-container",
          attrs: { "md-flex": "100" }
        },
        [
          _vm.subtitlesProp.length > 0
            ? _c(
                "md-layout",
                _vm._l(_vm.subtitlesProp, function(subtitle) {
                  return _c("div", { staticClass: "linkSubtitles" }, [
                    _c("span", [_vm._v("This video has subtitles. ")]),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "//" + _vm.subtitleBucketName + "/" + subtitle.path,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }
                      },
                      [_vm._v("Click here to open")]
                    )
                  ])
                }),
                0
              )
            : _vm._e(),
          _c(
            "div",
            { attrs: { "md-flex": "50" } },
            [
              _vm.subtitlesProp.length > 0
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-primary md-raised",
                      attrs: { id: "deleteBtn" },
                      on: { click: _vm.deleteSubtitle }
                    },
                    [_vm._v("delete")]
                  )
                : _vm._e(),
              _c(
                "md-button",
                {
                  staticClass: "md-primary md-raised",
                  on: { click: _vm.showSubtitlesHandle }
                },
                [_vm._v(_vm._s(_vm.textButtonSubtitle()))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.loading && _vm.showSubtitles
        ? _c("loader", { attrs: { loading: true, size: 40 } })
        : _vm._e(),
      !_vm.loading && _vm.showSubtitles
        ? _c(
            "md-layout",
            { staticClass: "lang-container", attrs: { "md-flex": "100" } },
            [
              _c(
                "md-layout",
                { staticClass: "options", attrs: { "md-flex": "10" } },
                [
                  _c(
                    "md-select",
                    {
                      attrs: { placeholder: "Select language" },
                      model: {
                        value: _vm.subtitles.language,
                        callback: function($$v) {
                          _vm.$set(_vm.subtitles, "language", $$v)
                        },
                        expression: "subtitles.language"
                      }
                    },
                    _vm._l(_vm.availableLanguages, function(language) {
                      return _c(
                        "md-option",
                        { key: language.code, attrs: { value: language.code } },
                        [_vm._v(_vm._s(language.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "40" } },
                [
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Select file to upload")]),
                      _c("md-file", {
                        attrs: { type: "file", accept: ".srt" },
                        on: { selected: _vm.onSrtJobFileSelected }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button md-raised",
                  attrs: { disabled: !_vm.uploadFile },
                  on: { click: _vm.handleSubtitleUpload }
                },
                [
                  _c("md-icon", {
                    attrs: { "md-iconset": "fa fa-cloud-upload-alt" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isEditMode && _vm.changeProp
        ? _c(
            "div",
            { staticClass: "container-info" },
            [
              _c("md-icon", {
                staticClass: "icon-info",
                attrs: { "md-iconset": "fa fa-info" }
              }),
              _c("p", { staticClass: "check-properties" }, [
                _vm._v("Changes will be applied when you click update.")
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6479b0c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6479b0c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/upload/SubtitleUploader.vue
// module id = 961
// module chunks = 0